const defaultState = {
  focusedOffice: {},
  focusedCampaign: {},
  legacySessionKey: null,
  accessToken: null,
  refreshToken: null,
  loginFailure: null,
  tokensInvalid: false,
  campaigns: [],
  sidebarClosed: false,
  vars: {},
};

const session = function (state = defaultState, action) {
  let st, t;
  switch (action.type) {
    case 'SET_LEGACY_SESSION_KEY':
      return {
        ...state,
        legacySessionKey: action.data,
      };

    case 'SET_REFRESH_TOKEN':
      return {
        ...state,
        refreshToken: action.data,
      };

    case 'SET_ACCESS_TOKEN':
      return {
        ...state,
        accessToken: action.data,
      };

    case 'SET_TOKENS_INVALID':
      return {
        ...state,
        tokensInvalid: action.bool,
      };

    case 'LOGIN_FAILURE':
      return {
        ...state,
        loginFailure: action.data,
      };

    case 'SET_FOCUSED_OFFICE':
      return {
        ...state,
        focusedOffice: action.data,
      };

    case 'SET_FOCUSED_CAMPAIGN':
      st = { ...state };
      t = st.campaigns.find((d) => d.id === action.data);
      if (t) {
        return {
          ...state,
          focusedCampaign: t,
        };
      } else {
        //need to flag error
        return state;
      }

    case 'SET_CAMPAIGN_LIST':
      return {
        ...state,
        campaigns: action.data,
      };

    case 'TOGGLE_SIDEBAR':
      return {
        ...state,
        sidebarClosed: !state.sidebarClosed,
      };

    case 'SET_SESSION_VAR':
      return {
        ...state,
        vars: {
          ...state.vars,
          [action.key]: action.value,
        },
      };

    case 'CLEAR_SESSION_VARS':
      return {
        ...state,
        vars: {},
      };

    default:
      return state;
  }
};

export default session;
